module.exports = __webpack_public_path__ + "img/icon_img13.97743913.png";